import { useState, useEffect, useRef } from 'react';

export const StatsSection = () => {
  const [isVisible, setIsVisible] = useState(false);
  const sectionRef = useRef(null);

  const stats = [
    { number: 30, suffix: '+', label: 'Years Experience', description: 'Decades of expert craftsmanship' },
    { number: 500, suffix: '+', label: 'Projects Completed', description: 'Delivered with quality and care' },
    { number: 50, suffix: '+', label: 'Skilled Tradespeople', description: 'Our team ensures top-quality results' },
    { number: 100, suffix: '%', label: 'Client Satisfaction', description: 'All clients satisfied with our work' },
  ];

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setIsVisible(true);
        }
      },
      { threshold: 0.3 }
    );

    if (sectionRef.current) {
      observer.observe(sectionRef.current);
    }

    return () => observer.disconnect();
  }, []);

  const CountUp = ({ end, suffix, isVisible }) => {
    const [count, setCount] = useState(0);

    useEffect(() => {
      if (!isVisible) return;

      const duration = 2000;
      const steps = 60;
      const increment = end / steps;
      let current = 0;

      const timer = setInterval(() => {
        current += increment;
        if (current >= end) {
          setCount(end);
          clearInterval(timer);
        } else {
          setCount(Math.floor(current));
        }
      }, duration / steps);

      return () => clearInterval(timer);
    }, [end, isVisible]);

    return (
      <span className="tabular-nums">
        {count}{suffix}
      </span>
    );
  };

  return (
    <section 
      ref={sectionRef}
      data-testid="stats-section" 
      className="py-20 bg-off-white"
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-2 lg:grid-cols-4 gap-8 lg:gap-12">
          {stats.map((stat, index) => (
            <div 
              key={index}
              className="text-center lg:text-left space-y-2"
              data-testid={`stat-${index}`}
            >
              <p className="text-5xl lg:text-6xl font-playfair font-bold text-navy">
                <CountUp end={stat.number} suffix={stat.suffix} isVisible={isVisible} />
              </p>
              <p className="text-lg font-playfair font-semibold text-navy">
                {stat.label}
              </p>
              <p className="text-sm font-inter text-navy/60">
                {stat.description}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default StatsSection;
